import LandingContainer from "./containers/LandingContainer";
import "./styles.scss";

export default LandingContainer;
